export default __webpack_public_path__ + "static/pict7-b85928c6f4fbae53624235d1378bc80e.png";